import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Particle from "../Particle";
import Github from "./Github";
import Techstack from "./Techstack";
import Aboutcard from "./AboutCard";
import laptopImg from "../../Assets/undraw_mobile_development_re_wwsn.svg";
import Toolstack from "./Toolstack";

function About() {
  return (
    <Container fluid className="about-section">
      <Particle />
      <Container>
        {/* Intro Section */}
        <Row style={{ justifyContent: "center", padding: "10px" }}>
          <Col
            md={7}
            style={{
              justifyContent: "center",
              paddingTop: "30px",
              paddingBottom: "50px",
            }}
          >
            <h1 style={{ fontSize: "2.1em", paddingBottom: "20px" }}>
              Get To Know <strong className="purple">Me</strong>
            </h1>
            <Aboutcard />
          </Col>
          <Col
            md={5}
            style={{ paddingTop: "120px", paddingBottom: "50px" }}
            className="about-img"
          >
            <img src={laptopImg} alt="about" className="img-fluid" />
          </Col>
        </Row>

        {/* Skills Section */}
        <h1 className="project-heading">
          Professional <strong className="purple">Skillset</strong>
        </h1>
        <p style={{ textAlign: "center", marginBottom: "30px", color: "#aaa" }}>
          Technologies I use to craft intuitive, efficient, and scalable solutions
        </p>
        <Techstack />

        {/* Tools Section */}
        <h1 className="project-heading">
          <strong className="purple">Tools</strong> I Use
        </h1>
        <p style={{ textAlign: "center", marginBottom: "30px", color: "#aaa" }}>
          From design to deployment — these are my daily drivers for building impactful products
        </p>
        <Toolstack />

        {/* GitHub Integration */}
        <Github />

        {/* Closing Tagline */}
        <div style={{ textAlign: "center", marginTop: "50px", color: "#FF3000" }}>
          <h4> Always curious. Always building. Always learning.</h4>
        </div>
      </Container>
    </Container>
  );
}

export default About;
